<!-- eslint-disable -->
<template lang="pug">
    .list
        .list__content
            .list__header
                | {{ $i18n.t('timetable.timetable_timetable_header') }}
            .list__fields(v-if="user && user.type !== 'student'")
                fields(@search="search")
            .list__body
                .calendar
                    div(v-show="!isLoading" ref="calendar")
                cs-loader(v-if="isLoading")
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from '../../api/school';
    import GradeApi from '../../api/grade';
    import UserApi from '../../api/user/user';
    import TimetableApi from '../../api/user/timetable'
    import TimetableMixin from '../../utils/user/timetable';
    import searchFieldsMixin from '../../utils/searchFieldsMixin';
    import _ from 'lodash';
    import {mapState} from 'vuex';
    import Fields from './Fields.vue'

    export default {
        mixins: [TimetableMixin, searchFieldsMixin],
        data() {
            return {
                isLoading: false,
                calendar: null
            }
        },
        mounted() {
            this.calendar = $(this.$refs.calendar).fullCalendar({
                locale: this.$i18n.locale,
                firstDay: 1,
                allDaySlot: false,
                height: 600,
                defaultView: 'month',
                timeFormat: 'HH:mm',
                slotLabelFormat : 'HH:mm',
                header: {
                    left: 'today prev,next title',
                    center: '',
                    right: 'agendaDay,agendaWeek,month '
                },
                buttonText: {
                    today: this.$i18n.t('timetable.timetable_buttonText_today'),
                    month: this.$i18n.t('timetable.timetable_buttonText_month'),
                    week: this.$i18n.t('timetable.timetable_buttonText_week'),
                    day: this.$i18n.t('timetable.timetable_buttonText_day')
                },
                eventRender(event) {
                    return (event.ranges.filter((range) => {
                            return (event.start.isBefore(range.end) &&
                            event.end.isAfter(range.start));
                        }).length) > 0;
                }
            });
            this.getTimetable({});
        },
        watch: {
            events(events) {
                let eventsForCalendar = _.map(events, (event) => {
                    if (event.time) {
                        let time = event.time.match(/[0-9:]+/g);
                        return {
                            dow: [event.day],
                            title: event.grade.name,
                            start: time[0],
                            end: time[1],
                            allDay: false,
                            ranges: [
                                {
                                    start: this.$moment(event.startDate),
                                    end: this.$moment(event.endDate)
                                }
                            ]
                        };
                    }
                });
                this.calendar.fullCalendar('removeEvents');
                if (this.calendar && this.calendar.fullCalendar) {
                    this.calendar.fullCalendar('addEventSource', eventsForCalendar);
                }
            }
        },
        methods: {
            getTimetable(params) {
                this.isLoading = true;
                TimetableApi.list(params)
                    .then((data) => {
                        this.isLoading = false;
                        this.$nextTick(() => {
                            this.events = _.toArray(data);
                            this.events.forEach((event) => {
                                if (event.day === 7) {
                                    event.day = 0;
                                }
                            });
                        })
                    }).catch((err) => {
                    this.isLoading = false;
                });
            },
            search(params) {
                this.getTimetable(params);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            })
        },
        components: {
          Fields
        }
    }
</script>

<style lang="scss" scoped>
    .list {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        font-weight: normal;
        @include media($sm) {
            padding: 30px;
            border-radius: $border-radius-40;
        }
        @media screen and (max-width: 568px) {
            border-radius: 0;
        }
    }

    .list__content {
        margin: 0;
        padding: 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        @include media($md) {
            padding: 30px;
        }
    }

    .list__header {
        padding: 15px 0;
        display: flex;
        flex-direction: column;

        font-weight: 500;
        font-size: 22px;
        line-height: 26px;

        @include media($lg) {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }

    .list__fields {
        padding: 0;
        margin: 15px 0 40px 0;
        @include media($xlg) {
            margin: 30px 0 25px 0;
            width: 100%;
        }
    }

    .list__body {
        display: grid;
    }

    @media screen and (max-device-width:450px) {
        .fc table {
            font-size: 0.8em !important;
        }
    }

    .calendar {
        overflow-x: auto;
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        padding: 16px 0;
        display: grid;
    }

    .fc {
        min-width: 948px !important;
        padding: 0 16px;
    }
</style>
